export const TYPES = {
  GENERIC_REQUEST: 'GENERIC_REQUEST',
  GENERIC_ERROR: 'GENERIC_ERROR',
  FETCH_ICW_WIDGET_DATA_SUCCESS: 'FETCH_ICW_WIDGET_DATA_SUCCESS',
};

export default {
  [TYPES.GENERIC_REQUEST](state, type) {
    const currentState = state;
    currentState[type].loading = true;
    currentState[type].successMessage = '';
    currentState[type].errorMessage = '';
  },
  [TYPES.GENERIC_ERROR](state, errorInfo) {
    const currentState = state;
    currentState[errorInfo.type].errorMessage = errorInfo.message;
    currentState[errorInfo.type].successMessage = '';
    currentState[errorInfo.type].loading = false;
  },
  /**
   * @param {import('./types').initialData} state
   * @param {import('./types').ICWWidgetData} widgetData
   */
  [TYPES.FETCH_ICW_WIDGET_DATA_SUCCESS](state, widgetData) {
    const currentState = state;
    currentState.widgetData = {
      ...currentState.widgetData,
      loading: false,
      ...widgetData,
    };
  },
};
